export const setCurrentTab = title => ({
  type: 'SET_CURRENT_TAB',
  payload: title
});

export default title => dispatch => {
  dispatch(setCurrentTab(title));
};
